import * as d3 from "d3";
import d3Legend from "d3-svg-legend";

function BubbleLegend(config){
    function createColorLegend(config){
        var ordinal = d3.scaleOrdinal()
        .domain(config.domain)
        .range(config.range);
        var legendClass=config.legendClass;
        const legendClasses=config.legendClasses;
        const symbol=config.symbol;

        if(config.hasOwnProperty("typeofscale")){
            var typeofscale=config.typeofscale;
            if(typeofscale.toLowerCase()=='scalelinear'){
                ordinal=d3.scaleLinear()
                .domain(config.domain)
                .range(config.range);
            }else if(typeofscale.toLowerCase()=='scalequantize'){
                ordinal=d3.scaleQuantize()
                .domain(config.domain)
                .range(config.range);
            }
        }

        var legendOrdinal = d3Legend.legendColor()
        .shapeWidth(config.rectWidth)
        .labelAlign("start")
        .orient(config.layout || 'horizontal')
        .labels(config.labels)
        .labelWrap(config.labelWrap)
        .shapePadding(config.rectPadding)
        .title(config.title)
        .scale(ordinal); 

        d3.selectAll("."+config.mainSvgId+" ."+legendClass+"").remove();
        var translatex=0;
        var translatey=0;
        if(config.align.toLowerCase()=='left' && config.verticalAlign.toLowerCase()=='top'){
            translatex=config.x;
            translatey=config.y;
        }else if(config.align.toLowerCase()=='right' && config.verticalAlign.toLowerCase()=='top'){
            translatex=config.mainSvgWidth-config.x;
            translatey=config.y;
        }else if(config.align.toLowerCase()=='left' && config.verticalAlign.toLowerCase()=='bottom'){
            translatex=config.x;
            translatey=config.mainSvgHeight-parseFloat(config.y);
        }else if(config.align.toLowerCase()=='right' && config.verticalAlign.toLowerCase()=='bottom'){
            translatex=config.mainSvgWidth-config.x;
            translatey=config.mainSvgHeight-parseFloat(config.y);
        }

        var colorLegendMainG=d3.selectAll("."+config.mainSvgId).append("g")
        .attr("transform","translate("+translatex+","+translatey+")")
        .attr("class",legendClass+" "+"multiSeriesLegend");
        
        d3.selectAll("."+config.mainSvgId+" ."+legendClass+"")
        .call(legendOrdinal);

        // if(config.align.toLowerCase()=='right' && config.verticalAlign.toLowerCase()=='top'){
        //     d3.selectAll("."+config.mainSvgId+" ."+legendClass+"")
        //     .attr("transform","translate("+(translatex- d3.selectAll("."+config.mainSvgId+" ."+legendClass+"").node().getBBox().width)+","+translatey+")")
        // }else if(config.align.toLowerCase()=='left' && config.verticalAlign.toLowerCase()=='bottom'){
        //     d3.selectAll("."+config.mainSvgId+" ."+legendClass+"")
        //     .attr("transform","translate("+translatex+","+(translatey- d3.selectAll("."+config.mainSvgId+" ."+legendClass+"").node().getBBox().height)+")")
        // }else if(config.align.toLowerCase()=='right' && config.verticalAlign.toLowerCase()=='bottom'){
        //     d3.selectAll("."+config.mainSvgId+" ."+legendClass+"")
        //     .attr("transform","translate("+(translatex- d3.selectAll("."+config.mainSvgId+" ."+legendClass+"").node().getBBox().width)+","+(translatey- d3.selectAll("."+config.mainSvgId+" ."+legendClass+"").node().getBBox().height)+")")
        // }

        d3.selectAll("."+config.mainSvgId+" ."+legendClass+" text")
        .style("font-size",config.labelFontSize ||  "12px")
        .style("font-family",config.labelFontFamily || "")
        .style("fill",config.labelFontColor || "#000");

        d3.selectAll("."+config.mainSvgId+" ."+legendClass+" .legendTitle")
        .style("font-weight","800");
        //CBT:This is for display in line Lables for horizontal  layout start
        if(config.hasOwnProperty("displayInLine")==true && typeof(config.displayInLine)=='object' && config.layout=="horizontal" && d3.selectAll("."+config.mainSvgId+" ."+legendClass+" .cell text tspan").node()){
            // In firefox .getBBox().y throws error
            try {
                var rectWidth=config.displayInLine.rectWidth || 15;
                var rectHeight=config.displayInLine.rectHeight || rectWidth;
                var rectPadding=config.rectPadding || 1;
                var textTspanYPosition=d3.selectAll("."+config.mainSvgId+" ."+legendClass+" .cell text tspan").node().getBBox().y;
                d3.selectAll("."+config.mainSvgId+" ."+legendClass+" .cell rect").attr("width",rectWidth);
                d3.selectAll("."+config.mainSvgId+" ."+legendClass+" .cell rect").attr("height",rectHeight);
                d3.selectAll("."+config.mainSvgId+" ."+legendClass+" .cell text").attr("transform","translate("+(rectWidth+rectPadding)+","+(textTspanYPosition * -1)+")");
            } catch(error) {
                console.error(error);
            }
        }
        var lastLegendElements=config.lastLegendElements;
        if(config.hasOwnProperty('disabledSeriesIndex')==true){
            d3.selectAll("."+config.mainSvgId+" ."+legendClass+" .cell").each(function(g,index){
                if(config.disabledSeriesIndex.indexOf(index+lastLegendElements)!=-1){
                    d3.select(this).select('text').style('fill-opacity',0.5);
                }
            })
        }
        //CBT:This is for display in line Lables for horizontal  layout end
        //CBT:add classes to each legend start 
        if(legendClasses!=null && legendClasses.length>0){
            d3.selectAll("."+config.mainSvgId+" ."+legendClass+" .cell").each(function(g,index){
                d3.select(this).attr('class',d3.select(this).attr('class')+' '+(legendClasses[index]!=null ? legendClasses[index] : legendClasses[0]));
            })
        }
        //CBT:add classes to each legend end 
        //CBT:convert rect to line (support line symbol) start
        if(symbol!=null && symbol=='line'){
            d3.selectAll("."+config.mainSvgId+" ."+legendClass+" .cell").each(function(g,index){
                d3.select(this).
                append('line').attr("x1",0).attr("y1",0).attr("x2",d3.select(this).select('rect').attr('width')).attr("y2",0)
                .style("stroke-width",d3.select(this).select('rect').attr('height'))
                .style("stroke",d3.select(this).select('rect').style('fill'));
                d3.select(this).select('rect').remove();
            })
        }
        //CBT:convert rect to line (support line symbol) end
        //CBT:this is for show hide chart based on legend click start
        
        if(config.hasOwnProperty("enableLegendClick")==true && typeof(config.enableLegendClick)=='object'){
            var onLegendClick=config.enableLegendClick.onLegendClick || function(){
                return;
            };
            var disabledSeriesIndex=config.disabledSeriesIndex || [];
            d3.selectAll("."+config.mainSvgId+" ."+legendClass+" .cell")
            .style("cursor","pointer")
            .on("click",function(d,index){
                onLegendClick(d,lastLegendElements+index);
            });
        }
        
        //CBT:this is for show hide chart based on legend click end

    }
    return {
        createColorLegend
    };
}
const legend = BubbleLegend();
export default legend;
